var qs = require('qs')
let dayjsFn = null
let parsed = null
export function validateParamsRD(params, dayjs, store = null, minNights = 30) {
  store.commit('searchbar/setQueryParams', params, { root: true })
  dayjsFn = dayjs
  const errors = {}

  try {
    if (!params.croproposal && sessionStorage.getItem("croproposal")) {
      params.croproposal = sessionStorage.getItem("croproposal")
    } else if (params.croproposal) {
      sessionStorage.setItem("croproposal", params.croproposal)
    }
  } catch (e) {
    console.log("Error with croproposal")
  }

  const queryString = sorted({
    ...params
  })

  // Required fields
  const required = ['fini', 'fout', 'nadults1', 'hotelId']
  const mandatoryFields = requiredFields(required, queryString)

  if (mandatoryFields.notFound.length) {
    errors['paramNotFound'] = {
      message: `Faltan parametros. Necesarios: [${required.join(', ')}]`,
      notValid: mandatoryFields.notFound,
      valid: mandatoryFields.found,
      required
    }
  }

  // Dates format
  if (!(validFormatDate(queryString.fini) || !validFormatDate(queryString.fout))) {
    // formato de fechas
    errors['datesFormat'] = {
      message: 'El formato de fechas es incorrecto',
      FechaInicio: queryString.fini,
      FechaFin: queryString.fout
    }
  }

  // Diff dates
  const diff = datesDiff(queryString.fini, queryString.fout)
  if (!diff.equalAfter || !diff.olderTodayDateIn || !diff.olderTodayDateOut) {
    errors['datesValid'] = {
      message: 'La lógica fechas incorrectas',
      equalAfter: diff.equalAfter,
      olderTodayDateIn: diff.olderTodayDateIn,
      olderTodayDateOut: diff.olderTodayDateOut
    }
  }

  // Num nights
  const limitNight = minNights
  let nights = numNights(queryString.fini, queryString.fout)

  if (nights > limitNight) {
    errors['numNight'] = {
      message: `El numero de noches [${nights}] es mayor que el limite [${limitNight}]`
    }
  }

  // Ocuppancy format
  const selectOccupancy = occupancy(queryString)
  if (Object.keys(selectOccupancy.errors).length) {
    errors['occupancy'] = {
      message: 'Hay parametros de ocupación incorrectos',
      occupancyErrors: selectOccupancy.errors
    }
  }

  // Ocuppancy logic
  if (selectOccupancy.rooms > 0) {
    var roomsOccupancy = ocupancyForRooms(selectOccupancy.rooms, selectOccupancy.occupancy, occupancy)
    if (Object.entries(roomsOccupancy.errors).length) {
      errors['occupancyLogic'] = {
        message: 'La ocupación por room es incorrecta',
        occupancyErrors: roomsOccupancy.errors,
        occupancy: roomsOccupancy.occupancy
      }
    }
  }

  // trazamos errorres si hay
  errors.total = Object.entries(errors).length

  //gestionamos errores si hay
  const hasHotelId = !mandatoryFields.notFound.includes('hotelId')
  if (hasHotelId) {
    if (errors['datesValid'] || errors['datesFormat'] || errors['numNight']) {
      queryString.fini = dayjsFn(new Date().getTime()).format('DD/MM/YYYY')
      queryString.fout = dayjsFn(new Date().getTime()).add(1, 'day').format('DD/MM/YYYY')
      nights = 1
    }
    if (errors['occupancy'] || errors['occupancyLogic']) {
      for (let key in queryString) {
        if (key.includes('nadults') || key.includes('nchilds') || key.includes('nbabies')) delete queryString[key]
      }
      queryString.nadults1 = 2
      queryString.nchilds1 = 0
      queryString.nbabies1 = 0
      if (roomsOccupancy) {
        roomsOccupancy.occupancy = [{
          "nadults": 2,
          "nchilds": 0,
          "nbabies": 0,
          "total": 2
        }]
      } else {
        var roomsOccupancy = {}
        roomsOccupancy.occupancy = [{
          "nadults": 2,
          "nchilds": 0,
          "nbabies": 0,
          "total": 2
        }]
      }
    }
  }

  // Parseamos si no hay error de hotelId
  if(roomsOccupancy && hasHotelId) {
    const valid = (({ fini, fout, hotelId, gvoucher, voucherCode, pcode, bd, divisa }) => ({
      fini,
      fout,
      hotelId,
      gvoucher,
      voucherCode,
      pcode,
      bd,
      divisa
    }))(queryString)
    const data = parsedParams({
      ...valid,
      nights,
      rooms: roomsOccupancy.occupancy,
      roomsTotal: roomsTotal(roomsOccupancy.occupancy),
      queryString
    })
    store.commit('searchbar/setQuerySearch', data, { root: true })
  }
  store.commit('searchbar/setErrors', errors, { root: true })
  return { errors, params }
}
export function parsedParams(param) {
  parsed = param ? param : parsed
  return parsed
}

// HELPERS
const validate = (date, format) => dayjsFn(date, format).format(format) === date

const sorted = (obj) =>
  Object.keys(obj)
    .sort()
    .reduce((accumulator, key) => {
      accumulator[key] = obj[key]
      return accumulator
    }, {})

const occupancy = (queryString) => {
  // occupancy
  const keys = ['nadults', 'nchilds', 'nbabies']
  const maxPax = [12, 11, 2]
  const maxRooms = 9
  const occupancy = {}
  const errors = []
  const secuencialType = {} // para comprobar que que (adult1, adults2) y no falta ninguna room
  keys.forEach(function (element, indexElement) {
    const regex2 = new RegExp(`^${element}`)
    Object.keys(queryString).filter(function (key, index, value) {
      if (regex2.test(key) && /(\d+)(?!.*\d)/.test(key)) {
        // existe patron string + number (nadults3)
        const num = parseInt(key.match(/(\d+)(?!.*\d)/))
        if (typeof num === 'number' && num > 0 && num <= maxRooms) {
          // compruebo que el key es valido nadults1 = true, nadults25 = false
          if (!secuencialType[element]) secuencialType[element] = []
          secuencialType[element].push(num)
          const value = parseInt(queryString[key])
          if (((value >= 0 && element !== 'nadults') || (value > 0 && element === 'nadults')) && value <= maxPax[indexElement]) {
            // compruebo el número de pax correcto
            const obj = { [`${key}`]: value }
            if (!occupancy[element]) occupancy[element] = []
            occupancy[element].push(obj)
          } else errorsOcupancy(errors, 'valueInvalid', key, queryString[key])
        } else errorsOcupancy(errors, 'keyFormat', key, queryString[key])
      }
    })
  })

  // compruebo si es secuencial
  Object.assign(errors, ifSecuencial(secuencialType, errors))
  return {
    errors,
    secuencialType,
    rooms: occupancy['nadults'] ? occupancy['nadults'].length : 0,
    occupancy
  }
}

const errorsOcupancy = (errors, type, key, value) => {
  if (typeof errors[type] === 'undefined') errors[type] = []
  if (!errors[type].includes(key)) errors[type].push(key)
  return errors
}

const ocupancyForRooms = (rooms, occupancy) => {
  const roomsOccupancy = new Array()
  Object.keys(occupancy).map(function (objectKey, index) {
    let value = occupancy[objectKey]
    value.forEach(function (element, room) {
      // const key = Object.keys(element)[0]
      const pax = Object.values(element)[0]
      if (!roomsOccupancy[room]) roomsOccupancy[room] = {
        nadults: 0,
        nchilds: 0,
        nbabies: 0
      }
      if (!roomsOccupancy[room][objectKey]) roomsOccupancy[room][objectKey] = pax
    })
  })
  roomsOccupancy.map((a, i) => {
    const data = objToarray(a)
    roomsOccupancy[i]['total'] = data.reduce((accumulator, value) => {
      return accumulator + value[1]
    }, 0)
  })

  return ocuppancyForPax(roomsOccupancy)
}

const ocuppancyForPax = (occupancy) => {
  const errors = {}
  let defaultDatas = {
    limit: 12, // límite de suma de ocupaciones
    nadults: { min: 1, max: 12, selected: 2 },
    nchilds: { min: 0, max: 11, selected: 0 },
    nbabies: { min: 0, max: 2, selected: 0 }
  }
  occupancy.map((a, i) => {
    const data = objToarray(a)
    const total = data.reduce((accumulator, value) => {
      return value[0] != 'total' ? accumulator + value[1] : accumulator
    }, 0)
    if (total > defaultDatas.limit) {
      errors[`room ${i + 1}`] = {
        message: `El número de ocupaciones es incorrecto en room ${i + 1},  max ${defaultDatas.limit}`,
        total
      }
    }
  })
  return { occupancy, errors }
}
export function roomsTotal(data) {
  const totalElement = {
    nadults: 0,
    nchilds: 0,
    nbabies: 0,
    rooms: 0
  }
  data.forEach(function (element, index) {
    if(typeof element.nadults != 'undefined') totalElement.nadults += element.nadults
    if(typeof element.nchilds != 'undefined') totalElement.nchilds += element.nchilds
    if(typeof element.nbabies != 'undefined') totalElement.nbabies += element.nbabies
    totalElement.rooms++
  })
  return totalElement
}

const validFormatDate = (date, dateFormat = 'DD/MM/YYYY') => {
  return dayjsFn(date, dateFormat, true).isValid()
}

const requiredFields = (fields, queryString) => {
  const queryKeys = Object.keys(queryString)
  const notFound = fields.filter((x) => !queryKeys.includes(x))
  const found = fields.filter((x) => queryKeys.includes(x))
  if (found.length) {
    found.forEach((param) => {
      if (!(queryString[param] !== null && queryString[param] !== '')) notFound.push(param)
    })
  }

  return {
    notFound,
    found
  }
}

const datesDiff = (fini, fout, dateFormat = 'DD/MM/YYYY') => {
  const today = dayjsFn()
  const dateIn = dayjsFn(fini, dateFormat)
  const dateOut = dayjsFn(fout, dateFormat)

  const equalAfter = dateIn.isSameOrBefore(dateOut) // Fecha de ini es mayor que fecha fin
  const olderTodayDateIn = dateIn.diff(today, 'days') >= 0 // Fecha ini es anterior a fecha de hoy
  const olderTodayDateOut = dateOut.diff(today, 'days') >= 0 // Fecha fin es anterior a fecha de hoy

  return { equalAfter, olderTodayDateIn, olderTodayDateOut }
}

const objToarray = (obj) => Object.keys(obj).map((v) => new Array(v, obj[v]))

const ifSecuencial = (obj, errors) => {
  Object.entries(obj).forEach((entry) => {
    const [key, value] = entry
    if (!testSecuencial(value)) {
      if (typeof errors[`${key}-secuencial`] === 'undefined') errors[`${key}-secuencial`] = true
    }
  })
  return errors
}

const testSecuencial = (arr) => {
  const differenceAry = arr.slice(1).map((n, i) => n - arr[i])
  const isDifference = differenceAry.every((value) => value == 1)
  return arr[0] === 1 && isDifference
}

const numNights = (fini, fout, dateFormat = 'DD/MM/YYYY') => {
  const dateIn = dayjsFn(fini, dateFormat)
  const dateOut = dayjsFn(fout, dateFormat)
  return dateOut.diff(dateIn, 'd', true)
}
